/**
 * @name RejectDialog
 * @description Componente para poner comentario de rechazo de un backup
 * @author Gerardo de León
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

import { Icons, Layout, MUI, Typography } from '@styles';

const RejectDialog = (props) => {
  const {
    open,
    data,
    onClose,
    onRejectBackup,
  } = props;
  //console.log('data', data);
  const values = {
    id: data.IdBackup,
    comment: '',
  };

  const schema = Yup.object({
    comment: Yup.string()
      .min(2, i18n.t('FormsGeneralTexts.min2Chars'))
      .max(250, i18n.t('FormsGeneralTexts.max250Chars'))
      .required('*')
  });

  // RECHAZAR - Solo se puede rechazar si no empieza el día de mañana el periodo de backup.
  const tomorrow = moment().add(1, 'days');
  const canReject = moment(data.FechaInicio) > tomorrow;
  //console.log('canReject', canReject)
  // if (Date.parse($scope.backupToCR.FechaInicio) > Date.parse(tomorrow)) {

  return (
    <Formik
      initialValues={values}
      validationSchema={schema}
      isInitialValid={schema.isValidSync(values)}
      onSubmit={(values, { setSubmitting }) => {
        onRejectBackup(values, data, setSubmitting);
      }}
    >
      {(formikProps) => (
        <MUI.Dialog
          open={open}
          onClose={onClose}
          maxWidth="sm"
        >
          <MUI.DialogTitle>
            {i18n.t('BackupSettings.rejectBackup')}
            <MUI.DialogBoxClose onClick={onClose}>
              <Icons.Close />
            </MUI.DialogBoxClose>
          </MUI.DialogTitle>

          <MUI.DialogContent>
            <MUI.Box padding="8px">
              <Typography.Text>
                {i18n.t('BackupSettings.sureRejectBackup')}
              </Typography.Text>
            </MUI.Box>
            {/* Comentario */}
            <MUI.Box padding="8px">
              <MUI.TextField
                multiline
                label={i18n.t('GenericMessages.comment')}
                type="text"
                name="comment"
                value={formikProps.values.comment}
                characterLimit={250}
                onBlur={formikProps.handleBlur}
                onChange={formikProps.handleChange}
                error={Boolean(formikProps.touched.comment && formikProps.errors.comment)}
                helperText={formikProps.touched.comment && formikProps.errors.comment}
                inputProps={{ maxLength: '250' }}
              />
            </MUI.Box>
          </MUI.DialogContent>

          <MUI.DialogActions>
            <Layout.BoxRequired>
              {`* ${i18n.t('FormsGeneralTexts.required')}`}
            </Layout.BoxRequired>
            <MUI.ButtonText onClick={onClose}>
              {i18n.t('DialogConfirm.cancel')}
            </MUI.ButtonText>
            <MUI.ButtonCTA
              type="button"
              color="primary"
              disabled={!formikProps.isValid || formikProps.isSubmitting}
              onClick={formikProps.handleSubmit}
            >
              {i18n.t('DialogConfirm.reject')}
            </MUI.ButtonCTA>
          </MUI.DialogActions>
        </MUI.Dialog>
      )}
    </Formik>
  );
};

RejectDialog.propTypes = {
  // Objeto con información para el modal.
  data: PropTypes.object,
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta cuando se cierra el modal.
  onClose: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se rechaza un backup.
  onRejectBackup: PropTypes.func.isRequired,
};

export default RejectDialog;
